export default function NumberFormat (values, mindig, maxdig) {
    const number = parseFloat(values);
    return number.toLocaleString(undefined, { minimumFractionDigits: isNaN(mindig) ? 0 : mindig, maximumFractionDigits: isNaN(maxdig) ? 0 : maxdig });
}